import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import TabbarHorizontal from './TabbarHorizontal.js';
import TabbarVertical from './TabbarVertical.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`Tabs organize content across different screens, data sets, and other interactions.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { TabItem, TabWrapper } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <h3>{`Horizontal`}</h3>
    <p>{`Doing so with Horizontal orientation by parsing `}<inlineCode parentName="p">{`horizontal`}</inlineCode>{` value to the `}<inlineCode parentName="p">{`variant`}</inlineCode>{` property.`}</p>
    <div>
  <TabbarHorizontal mdxType="TabbarHorizontal" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { Card, TabWrapper, TabItem } from "legion-ui";
import { navigate } from "gatsby";

const TabbarHorizontal = () => {
  const handleClickTab = () => navigate("https://legion.telkom.design/");
  return (
    <div style={{ marginBottom: "30px", width: "630px" }}>
      <h4>Horizontal</h4>
      <Card style={{ paddingLeft: "24px" }}>
        <TabWrapper variant="horizontal" style={{ marginRight: "24px" }} tabName="tabOne">
          <TabItem id="tab4" label="Product" isActive={true} />
          <TabItem id="tab5" label="Detail" icon="Info" isDisabled={true} />
          <TabItem id="tab6" label="Variant" />
          <TabItem id="tab7" label="Color Option" badgeNumber="4" />
          <TabItem id="tab8" label="Link Action" onClick={handleClickTab} />
          <TabItem id="tab9" label="Term and Condition" />
        </TabWrapper>
      </Card>
    </div>
  );
};

export default TabbarHorizontal;
`}</code></pre>
    <h3>{`Vertical`}</h3>
    <p>{`You can also have vertical Tab Bar and expect results! Give the `}<inlineCode parentName="p">{`variant`}</inlineCode>{` property a value of `}<inlineCode parentName="p">{`vertical`}</inlineCode>{`.`}</p>
    <div>
  <TabbarVertical mdxType="TabbarVertical" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { Card, TabWrapper, TabItem } from "legion-ui";

const TabbarVertical = () => {
  return (
    <div style={{ marginBottom: '30px', width: '630px' }}>
      <h4> Vertical </h4>
      <Card style={{ paddingLeft: '24px' }}>
        <TabWrapper style={{ marginRight: '24px' }} variant="vertical" tabName="tabTwo">
          <TabItem id="tab10" label="Product" isActive={true} />
          <TabItem id="tab11" label="Detail" icon='Info' />
          <TabItem id="tab12" label="Variant" />
          <TabItem id="tab13" label="Color Option" badgeNumber='4' />
        </TabWrapper>
      </Card>
    </div>
  );
};

export default TabbarVertical;
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <h3>{`TabWrapper`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`tabName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✓`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets and identify the name of Tab Bar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`variant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`horizontal`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`vertical`}</inlineCode>{` `}{`|`}{` -`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`horizontal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets position of the Tab Bar`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3>{`TabItem`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`badgeNumber`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show badge number to the right side of Tab Bar item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`icon`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`IconName from `}<a parentName="td" {...{
              "href": "https://feathericons.com/"
            }}>{`react-feather`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets icon of Tab Bar item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✓`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets id of Tab Bar item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isActive`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets status of Tab Bar item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isDisabled`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets disable state to a Tab Bar item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets label of Tab Bar item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onClick`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`(e:React.ChangeEvent<HTMLInputElement>) => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Define tab bar onClick event. This will turn tab bar into clickable mode (pressed state)`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      